import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { LOGO_URL } from "@/lib/constants";
import Footer from "@/components/landing/Footer";

export default function LegalLayout({ title, lastUpdated, children }) {
  return (
    <div className="min-h-screen bg-white text-slate-900">
      <header className="sticky top-0 z-50 glass">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 sm:h-20 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5" data-testid="legal-nav-logo">
            <img src={LOGO_URL} alt="PamaPay" className="h-9 w-9 rounded-lg" />
            <span className="font-display font-black tracking-tight text-lg sm:text-xl text-slate-900">
              PamaPay
            </span>
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm text-slate-600 hover:text-slate-900"
            data-testid="legal-back-home"
          >
            <ArrowLeft className="w-4 h-4" /> Back to home
          </Link>
        </div>
      </header>

      <section className="relative pt-24 sm:pt-32 pb-12 overflow-hidden">
        <div className="absolute inset-0 hero-spotlight pointer-events-none" />
        <div className="absolute inset-0 dot-grid opacity-60 pointer-events-none" />
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-xs uppercase tracking-[0.2em] text-[#3B6FBF] font-bold mb-4">
            Legal
          </div>
          <h1 className="font-display font-black tracking-tighter text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-slate-900" data-testid="legal-title">
            {title}
          </h1>
          {lastUpdated && (
            <p className="mt-4 text-sm text-slate-500 font-mono-data" data-testid="legal-updated">
              Last updated: {lastUpdated}
            </p>
          )}
        </div>
      </section>

      <main className="pb-24">
        <article className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 prose-pamapay" data-testid="legal-content">
          {children}
        </article>
      </main>

      <Footer />
    </div>
  );
}
